import { mode } from '@chakra-ui/theme-tools';

export const ButtonComponent = {
  // style object for base or default style
  baseStyle: {
    px: 4,
    py: 2,
  },
  // styles for different sizes ("sm", "md", "lg")
  sizes: {},
  // styles for different visual variants ("outline", "solid")
  variants: {
    base: {
      _hover: {
        bg: '#B72618 !important',
      },
      bg: '#B72618',
      color: '#FFF',
      fontWeight: 'normal',
      fontSize: '14px',
      border: '1px solid #B72618',
      minWidth: '100px',
      _focus: { background: '#a1170a' },
    },
    'dottedBorder-button': (props) => ({
      border: '1px dashed #717476',
      borderRadius: '10px',
      background: mode('#FFFFFF', '#131313')(props),
      fontSize: '16px',
      color: '#666',
      fontWeight: 'normal',
    }),
    link: {
      color: '#B72618',
      // textDecoration: 'underline',
      fontWeight: 'normal',
      _focus: { textDecoration: 'underline' },
    },
    'cancel-button': {
      fontWeight: 'normal',
      height: '31px',
      maxHeight: '100px',
      border: '1px',
      _focus: { background: '#e2e3e4' },
    },
  },
  // default values for `size` and `variant`
  defaultProps: {
    size: '',
    variant: 'base',
  },
};
export const TableComponent = {
  variants: {
    spiritTable: (props) => ({
      tr: {
        borderColor: '#333',
        borderBottomWidth: '1px',
        bg: mode('#F8F7F7', '#1F1F1F')(props),
        _odd: {
          bg: mode('#FFFFFF', '#131313')(props),
          color: mode('#000', '#FFF')(props),
        },
      },
      th: {
        fontSize: '16px',
        background: 'brand.lightpink',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        bg: mode('#FFF0EF', '#4B1F1A')(props),
      },
      td: {
        fontSize: '14px',
      },
    }),
    itemTable: (props) => ({
      tr: {
        bg: mode('#F8F7F7', '#1F1F1F')(props),
        _odd: {
          bg: mode('#FFFFFF', '#131313')(props),
        },
      },
      th: {
        fontSize: '12px',
        color: mode('#000', '#FFF')(props),
        bg: mode('#F8F7F7', '#1F1F1F')(props),
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        borderRight: '1px solid #717476',
      },
      td: {
        fontSize: '14px',
        borderRight: '1px solid #717476',
        color: mode('#000', '#FFF')(props),
      },
    }),
    dashboardTable: (props) => ({
      tr: {
        border: '1px solid #ACABAB !important',
        color: mode('#767676', '#fff')(props),
        verticalAlign: 'middle',
        borderColor: '#c4c4c4',
        _even: {
          bg: mode('#F8F7F7', '#131313')(props),
        },
      },

      th: {
        borderTop: '1px solid #ACABAB !important',
        py: '15px',
        bg: mode('#FFF0EF', '#4B1F1A')(props),
        color: mode('#767676', '#fff')(props),
        paddingLeft: '2px',
        paddingRight: '2px',
        fontSize: 'lg',
        textTransform: 'title',
      },
      td: {
        fontSize: '14px',
        paddingLeft: '2px',
        paddingRight: '2px',
        marginTop: '10px',
        marginBottom: '10px',
      },
    }),
  },
};

// export const ModalComponent = {
//     sizes: {
//         lg: {
//             bg: "red",
//             w: '800px',
//         }
//     }//{ base: '100%', lg: '500px' },
// }
